<template>
  <div>
    <v-card flat width="100%" max-height="300px" class="overflow-hidden overflow-y-auto">
      <v-card-text>
        <element v-for="(msg, index) in messages" :key="index">
          <p class="body-2 font-weight-bold">{{viewAuthor(msg.author)}}</p>
          <p class="body-1 font-weight-medium">{{msg.text}}</p>
          <p class="caption text-xs-right font-italic">{{getRelativeTime(msg.createdAt)}}</p>
          <v-divider></v-divider>
        </element>
      </v-card-text>
    </v-card>
    <v-card-actions v-if="type === 'internal_notes' && isClient">
      <v-textarea :label="label" rows="2" auto-grow v-model="messageText"></v-textarea>
      <v-btn small text @click="sendMessage()">
        Save
        <v-icon float-right>check</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="type !== 'internal_notes'">
      <v-textarea :label="label" rows="2" auto-grow v-model="messageText"></v-textarea>
      <v-btn small text @click="sendMessage()">
        Save
        <v-icon float-right>check</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import store from '@/store';
import moment from 'moment';
export default {
  name: 'PostChatBox',
  props: ['messages', 'label', 'isClient', 'type'],
  data() {
    return {
      messageText: ''
    };
  },
  methods: {
    sendMessage: function() {
      if (this.messageText === '') {
        this.$swal.fire("Message can't be empty", '', 'error');
      } else {
        this.$emit('commented', this.messageText);
        this.messageText = '';
      }
    },
    reloadMessage: function() {
      this.$emit('reloadMessage');
    },
    getRelativeTime: function(date) {
      return moment(date).fromNow();
    },
    viewAuthor(author) {
      return store.state.user.id !== author.id ? author.name : 'You';
    }
  }
};
</script>



// WEBPACK FOOTER //
// PostChatBox.vue?4ca6a424